module.exports = __webpack_public_path__ + "img/status-page-secton-create.eec66a4b.png";